import { render, staticRenderFns } from "./youtubeSettings.vue?vue&type=template&id=39aa5588"
import script from "./youtubeSettings.vue?vue&type=script&lang=js"
export * from "./youtubeSettings.vue?vue&type=script&lang=js"
import style0 from "./youtubeSettings.vue?vue&type=style&index=0&id=39aa5588&prod&lang=css"
import style1 from "./youtubeSettings.vue?vue&type=style&index=1&id=39aa5588&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports